import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '/app/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private httpClient: HttpClient) { }

  public getUsers(page: number = 0, size: number = 15): Observable<any> {

    const url = environment.api + '/members/list';

    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    return this.httpClient.get<any>(url, { params });
  }


  public enableUser(id: string): Observable<any> {
    const url = `${environment.api}/members/${id}/enable`;
    return this.httpClient.post<any>(url, {}); // POST vacío
  }


  public disableUser(id: string): Observable<any> {
    const url = `${environment.api}/members/${id}/disable`;
    return this.httpClient.post<any>(url, {}); // POST vacío
  }


  public getUser(idUser: String) {
    return this.httpClient.get(`${environment.api}/members/${idUser}`);
  }

 public createUser(user: any) {
    return this.httpClient.post(`${environment.api}/members/invite`, user);
  }
}
